import React from "react";
import "../PagesCss/AreasAtuacao.css";
import BotaoWhatsapp from "../../component/BotaoWhatsapp";
import CTAWhatsapp from "../../component/CTAWhatsapp";

function SeguroRural() {
  return (
    <section className="area-page">
      <h1>Seguro Rural e Proagro</h1>

      <p>
        Depois de sofrerem amargamente com grandes quebras de produção, muitos
        produtores rurais (especialmente do setor de grãos) tem buscado se
        resguardar com a contratação de seguros rurais ou PROAGRO.
      </p>

      <p>
        Muitas vezes essas contratações são uma condição imposta pelas
        instituições financeiras para a concessão de crédito, já que o seguro é
        uma das modalidades de garantia aceita por bancos e cooperativas.
      </p>

      <p>
        O grande problema é que, cada vez mais, as seguradoras tem se negado a
        pagar as indenizações, mesmo diante da comprovação do sinistro, e aí
        aquilo que era para ser sinônimo de segurança acaba se tornando uma
        grande "dor de cabeça".
      </p>

      <p>
        Os motivos para negar o pagamento da indenização são os mais variados
        possíveis. Os mais comuns são: comunicação do sinistro fora do prazo,
        colheita antes da conclusão da vistoria, plantio em solo "tipo 1",
        inconsistência nas informações prestadas no formulário de riscos,
        implantação da lavoura em área previamente utilizada como pasto, falta
        de documentação (notas fiscais de todos os insumos aplicados, registro
        em carteira de todos os trabalhadores, etc.).
      </p>

      <p>
        Acontece que nada disso é explicado para o produtor no momento da
        contratação da apólice, e por isso as seguradoras se valem das famosas
        "letras miúdas" para inventarem burocracias que lhes permitam não pagar
        as indenizações devidas aos produtores.
      </p>

      <p>
        Se você precisa de ajuda para contratar, acompanhar, acionar, ou exigir
        o pagamento de uma apólice de seguro rural (mesmo que já tenha sido
        negado pela seguradora), clique no botão abaixo para falar gratuitamente
        com nossos especialistas, direto no seu WhatsApp.
      </p>

      <CTAWhatsapp text="Fale com um especialista" />

      <BotaoWhatsapp />
    </section>
  );
}

export default SeguroRural;
